const EnumActionType = {
  STATUS_CHANGE: "STATUS_CHANGE",
  REVIEWER_ASSIGNMENT: "REVIEWER_ASSIGNMENT",
  REVIEWER_ASSIGNMENT_REMOVED: "REVIEWER_ASSIGNMENT_REMOVED",
  REVIEWER_MAILED: "REVIEWER_MAILED",
  REVIEWER_ANSWER: "REVIEWER_ANSWER",
  REVIEWER_DECISION: "REVIEWER_DECISION",
  AE_ASSIGNMENT: "AE_ASSIGNMENT",
  AE_DECISION: "AE_DECISION",
  ASSISTANT_DECISION: "ASSISTANT_DECISION",
  EDITOR_DECISION: "EDITOR_DECISION",
};

export default EnumActionType;
